export const TILE_LAYER_EXTENT = [-3.036157, -6.374426, 47.743843, 48.530765];
export const TILE_GIRDE_EXTENT = [-180, -90, 180, 90];
export const TILE_GRIDE_ORIGIN = [-180, -90];

export const TILE_GRIDE_RESOLUTION = [
  1.40625, 0.703125, 0.3515625, 0.17578125, 0.087890625, 0.0439453125,
  0.02197265625, 0.010986328125, 0.0054931640625, 0.00274658203125,
  0.001373291015625, 0.0006866455078125, 0.00034332275390625,
];

export const TILE_GRIDE_TILE_SIZE = [256, 256];
export const VIEW_CENTER = [16.358718660549624, 21.987971414286215];
export const VIEW_EXTENT = [
  5.422611903425748, 14.250911192795211, 28.166718204701027, 31.482729239932066,
];
export const VIEW_ZOOM = 7.3;
export const VIEW_MAX_ZOOM = 12;
export const VIEW_PROJECTION = "EPSG:4326";
export const VIEW_ROTATION = 24;
const MAP_TILES = process.env.REACT_APP_MAP_TILES;
export function tileURL(tileCoord) {
  return MAP_TILES.replace("{z}", String(tileCoord[0]))
    .replace("{x}", String(tileCoord[1]))
    .replace("{y}", String(-1 - tileCoord[2]));
}
